import React from "react";
import AlertFilterSvg from "./Icons/DigitalTwin/AlertFilterSvg";
import SortSvg from "./Icons/Menu/SortSvg";
import ChartCarouselPreviousArrowIcon from "./Icons/DigitalTwin/ChartCarouselPreviousArrowSvg";
import ChartCarouselNextArrowIcon from "./Icons/DigitalTwin/ChartCarouselNextArrowSvg";
import NavbarAlertIcon from "./Icons/Navbar/AlertSvg";
import NavbarDigitalTwinIcon from "./Icons/Navbar/DigitalTwinSvg";
import NavbarMapIcon from "./Icons/Navbar/MapIconSvg";
import NavbarDiagnosticsIcon from "./Icons/Navbar/DiagnosticsSvg";
import ToastInfoIcon from "./Icons/DigitalTwin/ToastIconInfoSvg";
import BatteryChargingStateIcon from "./Icons/DigitalTwin/BatteryChargingStateSvg";
import BatteryDischargingStateIcon from "./Icons/DigitalTwin/BatteryDischargingStateSvg";
import BatteryIdleStateIcon from "./Icons/DigitalTwin/BatteryIdleStateSvg";
import OfflineIcon from "./Icons/DigitalTwin/OfflineSvg";
import OnlineIcon from "./Icons/DigitalTwin/OnlineSvg";
import ImageIcon from "./Icons/DigitalTwin/ImageSvg";
import DocumentIcon from "./Icons/DigitalTwin/DocumentSvg";
import NavbarBatteryHealthIcon from "./Icons/Navbar/BatteryHealthSvg";
import HeartWithLine from "./Icons/BatteryHealth/HeartWithLine";
import HeartWithBattery from "./Icons/BatteryHealth/HeartWithBattery";
import ChartSvg from "./Icons/BatteryHealth/ChartSvg";
import DegradationSvg from "./Icons/BatteryHealth/DegradationSvg";
import ChargingAnalyticsSvg from "./Icons/Navbar/ChargingAnalyticsSvg";
import ChargerPlugSvg from "./Icons/ChargingAnalytics/ChargerPlugSvg";
import ClockSvg from "./Icons/ChargingAnalytics/Clock";
import EnergyEfficiencySvg from "./Icons/ChargingAnalytics/EnergyEfficiencySvg";
import ChargingFrequencySvg from "./Icons/ChargingAnalytics/ChargingFrequencySvg";
import LocationSvg from "./Icons/Filters/LocationSvg";
import SelectDownArrowSvg from "./Icons/Filters/SelectDownArrowSvg";
import SelectUpArrowSvg from "./Icons/Filters/SelectUpArrowSvg";
import CalendarIconSvg from "./Icons/Filters/CalendarIconSvg";
import BarGraphSvg from "./Icons/AlertAnalytics/BarGraphSvg";
import AlertAnalyticsSvg from "./Icons/Navbar/AlertAnalyticsSvg";
import SearchIconSvg from "./Icons/Filters/SearchIconSvg";
import CloseSidebarSvg from "./Icons/Navbar/CloseSidebarSvg";
import ExpandSidebarSvg from "./Icons/Navbar/ExpandSidebarSvg";
import CheckedBoxSvg from "./Icons/Filters/CheckedBoxSvg";
import UncheckedBoxSvg from "./Icons/Filters/UncheckedBoxSvg";
import { BatteryIcon } from "./Icons/DigitalTwin/BatteryIcon";
import MapIcon from "./Icons/DigitalTwin/MapIcon";
import CustomAlertIcon from "./Icons/DigitalTwin/AlertICon";
import WarningIcon from "./Icons/DigitalTwin/WarningIcon";
import EditIcon from "./Icons/DigitalTwin/EditIcon";
import MinusCircleIcon from "./Icons/DigitalTwin/MinusCircleIcon";
import AddCircleIcon from "./Icons/DigitalTwin/AddCircleIcon";
import { PrimaryArrowIcon } from "./Icons/PrimaryArrowIcon";
import { LastNodeLevelIcon } from "./Icons/DigitalTwin/LastNodeLevelIcon";
import CircleInfoIcon from "./Icons/CircleInfoIcon";
import TrendLineIcon from "./Icons/TrendLineIcon";
import FilledTrendLineIcon from "./Icons/FilledTrendLineIcon";
import ThreeDotVertIcon from "./Icons/ThreeDotVertIcon";
import RefreshArrowIcon from "./Icons/RefreshArrowIcon";
import ClockArrowIcon from "./Icons/ClockArrowIcon";
import BatteryBarsIcon from "./Icons/BatteryBarsIcon";
import DraggableIcon from "./Icons/DraggableIcon";
import DownloadFileIcon from "./Icons/DownloadFileIcon";
import ImageDownloadIcon from "./Icons/ImageDownloadIcon";
import CopyIcon from "./Icons/CopyIcon";
import DotIcon from "./Icons/DotIcon";
import BinocularIcon from "./Icons/BinocularIcon";
import RedirectIcon from "./Icons/RedirectIcon";
import { ToastSuccessIcon } from "./Icons/ToastSuccessIcon";
import { BusIcon } from "./Icons/DigitalTwin/BusIcon";
import { TruckIcon } from "./Icons/DigitalTwin/TruckIcon";
import { NetworkStrengthIcon } from "./Icons/DigitalTwin/NetworkStrengthIcon";
import TrashIcon from "./Icons/DigitalTwin/TrashIcon";
import AlertCircleIcon from "./Icons/DigitalTwin/AlertCircleIcon";
import AdvancedAnalysisIcon from "./Icons/AdvancedAnalysis/AdvancedAnalysisIcon";
import AlertCircleFilledIcon from "./Icons/DigitalTwin/AlertCircleFilledIcon";
import DownArrowIcon from "./Icons/DigitalTwin/DownArrowIcon";
import GearIcon from "./Icons/DigitalTwin/GearIcon";
import WrenchIcon from "./Icons/FieldStatusIndicator/WrenchIcon";
import TrafficConeIcon from "./Icons/FieldStatusIndicator/TrafficConeIcon";
import OverviewIcon from "./Icons/Overview/OverviewIcon";
import ChargeIcon from "./Icons/Overview/ChargeIcon";
import DischargeIcon from "./Icons/Overview/DischargeIcon";
import PauseIcon from "./Icons/Overview/PauseIcon";
import DistanceIcon from "./Icons/Overview/DistanceIcon";
import UnderConstructionIcon from "./Icons/Overview/UnderConstructionIcon";
import DashboardIcon from "./Icons/Overview/DashboardIcon";
import BmsFaultIcon from "./Icons/BmsFaults/BmsFaultIcon";
import SmartAlertIcon from "./Icons/PlatformAlerts/SmartAlertIcon";
import FleetPerformanceIcon from "./Icons/FleetPerformance/FleetPerformanceIcon";
import BatteryIntelligenceIcon from "./Icons/BatteryIntelligence/BatteryIntelligenceIcon";
import CommentIcon from "./Icons/CommentIcon";
import DataUploadIcon from "./Icons/ResourceOnboarding/DataUploadIcon";
import CsvIcon from "./Icons/ResourceOnboarding/CsvIcon";
import RoundClockIcon from "./Icons/ResourceOnboarding/RoundClockIcon";
import CrossIcon from "./Icons/ResourceOnboarding/CrossIcon";
import TickCircleIcon from "./Icons/ResourceOnboarding/TickCircleIcon";
import VehicleBusIcon from "./Icons/ResourceOnboarding/VehicleBusIcon";
import IotConnectionIcon from "./Icons/ResourceOnboarding/IotConnectionIcon";
import InventoryUpdateIcon from "./Icons/ResourceOnboarding/InventoryUpdateIcon";
import InventoryReplaceIcon from "./Icons/ResourceOnboarding/InventoryReplaceIcon";
import { IotDeviceIcon } from "./Icons/DigitalTwin/IotDeviceIcon";
import DatabaseIcon from "./Icons/ResourceOnboarding/DatabaseIcon";
import HistoryIcon from "./Icons/HistoryIcon";
import OrgSettingsIcon from "./Icons/OrgSettings/OrgSettingsIcon";
import SupportedLocationsIcon from "./Icons/OrgSettings/SupportedLocationsIcon";
import LockPersonIcon from "@mui/icons-material/LockPerson";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import KeyMuiIcon from "@mui/icons-material/Key";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import ApiMuiIcon from "@mui/icons-material/Api";
import LayersOutlinedIcon from "@mui/icons-material/LayersOutlined";

const CustomIcon = (props) => {
  const { name, fill, height, width, viewBox, stroke, isSelected } = props;

  if (name === "alert-filter") {
    return (
      <AlertFilterSvg
        style={props.style}
        height={height}
        width={width}
        fill={fill}
        viewBox={viewBox}
        stroke={stroke}
        isSelected={isSelected}
      />
    );
  }
  if (name === "sort") {
    return (
      <SortSvg
        style={props.style}
        height={height}
        width={width}
        fill={fill}
        viewBox={viewBox}
        stroke={stroke}
        isSelected={isSelected}
      />
    );
  }
  if (name === "dot") {
    return (
      <OnlineIcon
        style={props.style}
        height={height}
        width={width}
        fill={fill}
        viewBox={viewBox}
        stroke={stroke}
        isSelected={isSelected}
      />
    );
  }

  if (name === "dot-icon") {
    return <DotIcon {...props} />;
  }

  if (name === "binocular-icon") {
    return <BinocularIcon {...props} />;
  }

  if (name === "chartCarouselPreviousArrow") {
    return (
      <ChartCarouselPreviousArrowIcon
        style={props.style}
        height={height}
        width={width}
        fill={fill}
        viewBox={viewBox}
        stroke={stroke}
        isSelected={isSelected}
      />
    );
  }
  if (name === "chartCarouselNextArrow") {
    return (
      <ChartCarouselNextArrowIcon
        style={props.style}
        height={height}
        width={width}
        fill={fill}
        viewBox={viewBox}
        stroke={stroke}
        isSelected={isSelected}
      />
    );
  }
  if (name === "navbarAlerts") {
    return (
      <NavbarAlertIcon
        style={props.style}
        height={height}
        width={width}
        fill={fill}
        viewBox={viewBox}
        stroke={stroke}
        isSelected={isSelected}
      />
    );
  }
  if (name === "navbarDigitalTwin") {
    return (
      <NavbarDigitalTwinIcon
        style={props.style}
        height={height}
        width={width}
        fill={fill}
        viewBox={viewBox}
        stroke={stroke}
        isSelected={isSelected}
      />
    );
  }
  if (name === "navbarDiagnostics") {
    return (
      <NavbarDiagnosticsIcon
        style={props.style}
        height={height}
        width={width}
        fill={fill}
        viewBox={viewBox}
        stroke={stroke}
        isSelected={isSelected}
      />
    );
  }
  if (name === "navbarMap") {
    return (
      <NavbarMapIcon
        style={props.style}
        height={height}
        width={width}
        fill={fill}
        viewBox={viewBox}
        stroke={stroke}
        isSelected={isSelected}
      />
    );
  }
  if (name === "toastInfo") {
    return (
      <ToastInfoIcon
        style={props.style}
        height={height}
        width={width}
        fill={fill}
        viewBox={viewBox}
        stroke={stroke}
        isSelected={isSelected}
      />
    );
  }

  if (name === "toast-success") {
    return <ToastSuccessIcon {...props} />;
  }

  if (name === "batteryChargingState") {
    return (
      <BatteryChargingStateIcon
        style={props.style}
        height={height}
        width={width}
        fill={fill}
        viewBox={viewBox}
        stroke={stroke}
        isSelected={isSelected}
      />
    );
  }
  if (name === "batteryDischargingState") {
    return (
      <BatteryDischargingStateIcon
        style={props.style}
        height={height}
        width={width}
        fill={fill}
        viewBox={viewBox}
        stroke={stroke}
        isSelected={isSelected}
      />
    );
  }
  if (name === "batteryIdleState") {
    return (
      <BatteryIdleStateIcon
        style={props.style}
        height={height}
        width={width}
        fill={fill}
        viewBox={viewBox}
        stroke={stroke}
        isSelected={isSelected}
      />
    );
  }
  if (name === "navbarBatteryHealth") {
    return (
      <NavbarBatteryHealthIcon
        style={props.style}
        height={height}
        width={width}
        fill={fill}
        viewBox={viewBox}
        stroke={stroke}
        isSelected={isSelected}
      />
    );
  }
  if (name === "offline") {
    return (
      <OfflineIcon
        style={props.style}
        height={height}
        width={width}
        fill={fill}
        viewBox={viewBox}
        stroke={stroke}
        isSelected={isSelected}
      />
    );
  }
  if (name === "online") {
    return (
      <OnlineIcon
        style={props.style}
        height={height}
        width={width}
        fill={fill}
        viewBox={viewBox}
        stroke={stroke}
        isSelected={isSelected}
      />
    );
  }
  if (name === "downloadData") {
    return (
      <DocumentIcon
        style={props.style}
        height={height}
        width={width}
        fill={fill}
        viewBox={viewBox}
        stroke={stroke}
        isSelected={isSelected}
      />
    );
  }
  if (name === "downloadImage") {
    return (
      <ImageIcon
        style={props.style}
        height={height}
        width={width}
        fill={fill}
        viewBox={viewBox}
        stroke={stroke}
        isSelected={isSelected}
      />
    );
  }
  if (name === "healthWithLine") {
    return <HeartWithLine height={height} width={width} />;
  }
  if (name === "healthWithBattery") {
    return <HeartWithBattery height={height} width={width} />;
  }
  if (name === "chart") {
    return (
      <ChartSvg
        style={props.style}
        height={height}
        width={width}
        fill={fill}
        viewBox={viewBox}
        stroke={stroke}
        isSelected={isSelected}
      />
    );
  }
  if (name === "degradation") {
    return (
      <DegradationSvg
        style={props.style}
        height={height}
        width={width}
        fill={fill}
        viewBox={viewBox}
        stroke={stroke}
        isSelected={isSelected}
      />
    );
  }
  if (name === "chargingAnalytics") {
    return (
      <ChargingAnalyticsSvg
        style={props.style}
        height={height}
        width={width}
        fill={fill}
        viewBox={viewBox}
        stroke={stroke}
        isSelected={isSelected}
      />
    );
  }
  if (name === "chargerPlug") {
    return (
      <ChargerPlugSvg
        style={props.style}
        height={height}
        width={width}
        fill={fill}
        viewBox={viewBox}
        stroke={stroke}
        isSelected={isSelected}
      />
    );
  }
  if (name === "clock") {
    return (
      <ClockSvg
        style={props.style}
        height={height}
        width={width}
        fill={fill}
        viewBox={viewBox}
        stroke={stroke}
        isSelected={isSelected}
      />
    );
  }
  if (name === "energyEfficiency") {
    return (
      <EnergyEfficiencySvg
        style={props.style}
        height={height}
        width={width}
        fill={fill}
        viewBox={viewBox}
        stroke={stroke}
        isSelected={isSelected}
      />
    );
  }
  if (name === "chargingFrequency") {
    return (
      <ChargingFrequencySvg
        style={props.style}
        height={height}
        width={width}
        fill={fill}
        viewBox={viewBox}
        stroke={stroke}
        isSelected={isSelected}
      />
    );
  }
  if (name === "mapIcon") {
    return (
      <LocationSvg
        style={props.style}
        height={height}
        width={width}
        fill={fill}
        viewBox={viewBox}
        stroke={stroke}
        isSelected={isSelected}
      />
    );
  }
  if (name === "downArrow") {
    return (
      <SelectDownArrowSvg
        sx={props.sx}
        style={props.style}
        height={height}
        width={width}
        fill={fill}
        viewBox={viewBox}
        stroke={stroke}
        isSelected={isSelected}
      />
    );
  }
  if (name === "upArrow") {
    return (
      <SelectUpArrowSvg
        style={props.style}
        height={height}
        width={width}
        fill={fill}
        viewBox={viewBox}
        stroke={stroke}
        isSelected={isSelected}
      />
    );
  }
  if (name === "calendar") {
    return (
      <CalendarIconSvg
        style={props.style}
        height={height}
        width={width}
        fill={fill}
        viewBox={viewBox}
        stroke={stroke}
        isSelected={isSelected}
      />
    );
  }
  if (name === "barGraph") {
    return (
      <BarGraphSvg
        style={props.style}
        height={height}
        width={width}
        fill={fill}
        viewBox={viewBox}
        stroke={stroke}
        isSelected={isSelected}
      />
    );
  }
  if (name === "analytics") {
    return (
      <AlertAnalyticsSvg
        style={props.style}
        height={height}
        width={width}
        fill={fill}
        viewBox={viewBox}
        stroke={stroke}
        isSelected={isSelected}
      />
    );
  }
  if (name === "closeSidebar") {
    return (
      <CloseSidebarSvg
        style={props.style}
        height={height}
        width={width}
        fill={fill}
        viewBox={viewBox}
        stroke={stroke}
        isSelected={isSelected}
      />
    );
  }
  if (name === "expandSidebar") {
    return (
      <ExpandSidebarSvg
        style={props.style}
        height={height}
        width={width}
        fill={fill}
        viewBox={viewBox}
        stroke={stroke}
        isSelected={isSelected}
      />
    );
  }
  if (name === "filterSearch") {
    return (
      <SearchIconSvg
        style={props.style}
        height={height}
        width={width}
        fill={fill}
        viewBox={viewBox}
        stroke={stroke}
      />
    );
  }
  if (name === "checkedBox") {
    return (
      <CheckedBoxSvg
        style={props.style}
        height={height}
        width={width}
        fill={fill}
        viewBox={viewBox}
        stroke={stroke}
      />
    );
  }
  if (name === "uncheckedBox") {
    return (
      <UncheckedBoxSvg
        style={props.style}
        height={height}
        width={width}
        fill={fill}
        viewBox={viewBox}
        stroke={stroke}
      />
    );
  }

  if (name === "battery-icon") {
    return <BatteryIcon {...props} />;
  }

  if (name === "bus-icon") {
    return <BusIcon {...props} />;
  }

  if (name === "truck-icon") {
    return <TruckIcon {...props} />;
  }

  if (name === "network-strength-icon") {
    return <NetworkStrengthIcon {...props} />;
  }

  if (name === "draggable-icon") {
    return <DraggableIcon {...props} />;
  }

  if (name === "battery-bar-icon") {
    return <BatteryBarsIcon {...props} />;
  }

  if (name === "map-icon") {
    return <MapIcon {...props} />;
  }

  if (name === "alert-icon") {
    return <CustomAlertIcon {...props} />;
  }

  if (name === "warning-icon") {
    return <WarningIcon {...props} />;
  }

  if (name === "edit-icon") {
    return <EditIcon {...props} />;
  }

  if (name === "minus-circle-icon") {
    return <MinusCircleIcon {...props} />;
  }

  if (name === "add-circle-icon") {
    return <AddCircleIcon {...props} />;
  }

  if (name === "primary-arrow-icon") {
    return <PrimaryArrowIcon {...props} />;
  }

  if (name === "last-node-level-icon") {
    return <LastNodeLevelIcon {...props} />;
  }

  if (name === "circle-info-icon") {
    return <CircleInfoIcon {...props} />;
  }

  if (name === "trend-line-icon") {
    return <TrendLineIcon {...props} />;
  }

  if (name === "filled-trend-line-icon") {
    return <FilledTrendLineIcon {...props} />;
  }

  if (name === "three-dot-vert-icon") {
    return <ThreeDotVertIcon {...props} />;
  }

  if (name === "refresh-arrow-icon") {
    return <RefreshArrowIcon {...props} />;
  }

  if (name === "clock-arrow-icon") {
    return <ClockArrowIcon {...props} />;
  }

  if (name === "download-file-icon") {
    return <DownloadFileIcon {...props} />;
  }

  if (name === "download-image-icon") {
    return <ImageDownloadIcon {...props} />;
  }

  if (name === "copy-icon") {
    return <CopyIcon {...props} />;
  }

  if (name === "redirect-icon") {
    return <RedirectIcon {...props} />;
  }

  if (name === "trash-icon") {
    return <TrashIcon {...props} />;
  }

  if (name === "alert-circle-icon") {
    return <AlertCircleIcon {...props} />;
  }

  if (name === "advanced-analysis-settings") {
    return <AdvancedAnalysisIcon {...props} />;
  }

  if (name === "alert-circle-filled-icon") {
    return <AlertCircleFilledIcon {...props} />;
  }

  if (name === "down-arrow-icon") {
    return <DownArrowIcon {...props} />;
  }

  if (name === "gear-icon") {
    return <GearIcon {...props} />;
  }

  // Field status indicator glyphs. Unlike the icons above these take their colour from
  // the caller (fill="currentColor"), so an org-configured colour has something to bind
  // to - see Components/FieldStatusIndicator.
  if (name === "status-maintenance") {
    return <WrenchIcon {...props} />;
  }

  if (name === "status-onboarding") {
    return <TrafficConeIcon {...props} />;
  }

  if (name === "overview") {
    return (
      <OverviewIcon
        style={props.style}
        height={height}
        width={width}
        fill={fill}
        viewBox={viewBox}
        stroke={stroke}
        isSelected={isSelected}
      />
    );
  }

  if (name === "bms-fault-icon") {
    return (
      <BmsFaultIcon
        style={props.style}
        height={height}
        width={width}
        fill={fill}
        viewBox={viewBox}
        stroke={stroke}
        isSelected={isSelected}
      />
    );
  }

  if (name === "smart-alert-icon") {
    return (
      <SmartAlertIcon
        style={props.style}
        height={height}
        width={width}
        fill={fill}
        viewBox={viewBox}
        stroke={stroke}
        isSelected={isSelected}
      />
    );
  }

  if (name === "fleet-performance-icon") {
    return (
      <FleetPerformanceIcon
        style={props.style}
        height={height}
        width={width}
        fill={fill}
        viewBox={viewBox}
        stroke={stroke}
        isSelected={isSelected}
      />
    );
  }

  if (name === "battery-intelligence-icon") {
    return (
      <BatteryIntelligenceIcon
        style={props.style}
        height={height}
        width={width}
        fill={fill}
        viewBox={viewBox}
        stroke={stroke}
        isSelected={isSelected}
      />
    );
  }

  if (name === "charge-icon") {
    return <ChargeIcon {...props} />;
  }

  if (name === "discharge-icon") {
    return <DischargeIcon {...props} />;
  }
  if (name === "pause-icon") {
    return <PauseIcon {...props} />;
  }
  if (name === "distance-icon") {
    return <DistanceIcon {...props} />;
  }
  if (name === "under-construction-icon") {
    return <UnderConstructionIcon {...props} />;
  }
  if (name === "dashboard-icon") {
    return <DashboardIcon {...props} />;
  }
  if (name === "comment-icon") {
    return <CommentIcon {...props} />;
  }
  if (name === "resource-onboarding") {
    return (
      <DataUploadIcon
        style={props.style}
        height={height}
        width={width}
        fill={fill}
        viewBox={viewBox}
        stroke={stroke}
        isSelected={isSelected}
      />
    );
  }
  if (name === "csv-icon") {
    return (
      <CsvIcon
        style={props.style}
        height={height}
        width={width}
        viewBox={viewBox}
      />
    );
  }
  if (name === "round-clock-icon") {
    return (
      <RoundClockIcon
        style={props.style}
        height={height}
        width={width}
        viewBox={viewBox}
        stroke={stroke}
      />
    );
  }
  if (name === "cross-icon") {
    return (
      <CrossIcon
        style={props.style}
        height={height}
        width={width}
        viewBox={viewBox}
        fill={fill}
      />
    );
  }
  if (name === "tick-circle-icon") {
    return (
      <TickCircleIcon
        style={props.style}
        height={height}
        width={width}
        viewBox={viewBox}
        stroke={stroke}
      />
    );
  }
  if (name === "vehicle-bus-icon") {
    return (
      <VehicleBusIcon
        style={props.style}
        height={height}
        width={width}
        viewBox={viewBox}
      />
    );
  }
  if (name === "iot-connection-icon") {
    return (
      <IotConnectionIcon
        style={props.style}
        height={height}
        width={width}
        viewBox={viewBox}
      />
    );
  }
  if (name === "iot-device-icon") {
    return <IotDeviceIcon />;
  }
  if (name === "inventory-update-icon") {
    return (
      <InventoryUpdateIcon
        style={props.style}
        height={height}
        width={width}
        viewBox={viewBox}
      />
    );
  }
  if (name === "inventory-replace-icon") {
    return (
      <InventoryReplaceIcon
        style={props.style}
        height={height}
        width={width}
        viewBox={viewBox}
      />
    );
  }
  if (name === "database-icon") {
    return (
      <DatabaseIcon
        style={props.style}
        height={height}
        width={width}
        viewBox={viewBox}
        stroke={stroke}
      />
    );
  }
  if (name === "history-icon") {
    return <HistoryIcon {...props} />;
  }
  if (name === "access-management-icon") {
    return <LockPersonIcon style={props.style} sx={{ color: isSelected ? "#6D72F6" : "#989898", fontSize: "inherit" }} />;
  }
  if (name === "org-settings-icon") {
    return <OrgSettingsIcon isSelected={isSelected} style={props.style} />;
  }
  if (name === "location-on-icon") {
    return <SupportedLocationsIcon isSelected={isSelected} style={{ ...props.style, fontSize: 13 }} />;
  }
  // Asset Management. Deliberately NOT navbarDigitalTwin, which Inventory
  // already uses -- two nav entries with the same glyph are indistinguishable
  // once the drawer is collapsed to icons. Layers matches the stacked-plane
  // mark in the reference design and comes from the MUI set already in use
  // here, so there is no new SVG to maintain.
  if (name === "asset-management-icon") {
    return (
      <LayersOutlinedIcon
        style={props.style}
        sx={{ color: isSelected ? "#6D72F6" : "#989898", fontSize: "inherit" }}
      />
    );
  }
  if (name === "api-icon") {
    return <ApiMuiIcon style={props.style} sx={{ color: isSelected ? "#6D72F6" : "#989898", fontSize: "inherit" }} />;
  }
  if (name === "supervisor-account-icon") {
    return <SupervisorAccountIcon style={props.style} sx={{ color: isSelected ? "#6D72F6" : "#989898", fontSize: "inherit" }} />;
  }
  if (name === "key-icon") {
    return <KeyMuiIcon style={props.style} sx={{ color: isSelected ? "#6D72F6" : "#989898", fontSize: "inherit" }} />;
  }
  if (name === "data-menu-icon") {
    return (
      <DataUploadIcon
        style={props.style}
        height={height}
        width={width}
        fill={fill}
        viewBox={viewBox}
        stroke={stroke}
        isSelected={isSelected}
      />
    );
  }
  if (name === "data-upload-icon") {
    return <FileUploadIcon style={props.style} sx={{ color: isSelected ? "#6D72F6" : "#989898", fontSize: "inherit" }} />;
  }
  if (name === "data-download-icon") {
    return <FileDownloadIcon style={props.style} sx={{ color: isSelected ? "#6D72F6" : "#989898", fontSize: "inherit" }} />;
  }
};

export default CustomIcon;
